module.exports = __webpack_public_path__ + "nm-icons_82c8beac438d1f2ecb1b878b0a690423.ttf?0a9f94d643ae66adf5ecbe2217d64d12";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/iconfont/nm-icons_82c8beac438d1f2ecb1b878b0a690423.ttf
// module id = 1394
// module chunks = 35